/**
 * Dahili (same-origin) yönlendirme yolu doğrulaması.
 * Open redirect: //evil.com veya /login?next=//evil.com gibi saldırıları engeller.
 */
export function isSafeInternalPath(path: string | null | undefined): boolean {
  if (!path || typeof path !== 'string') return false;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) return false;
  if (trimmed.startsWith('//')) return false;
  if (trimmed.includes('://') || trimmed.includes('\\')) return false;
  if (trimmed.includes('\0')) return false;
  return true;
}

export function resolveSafeRedirect(
  path: string | null | undefined,
  fallback = '/dashboard'
): string {
  return isSafeInternalPath(path) ? path!.trim() : fallback;
}
